export default __webpack_public_path__ + "static/media/bannerCar.85542064.png";